import React, { Component } from 'react';
import {Assets} from "../../enums";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {authRegistration} from "../Auth/auth.actions"; // Import your logo image file
import PropTypes from "prop-types";
import { branding } from '../../config/portalBranding';
import country from 'config/countryConfig';
import LanguageToggle from '../Common/LanguageToggle';
import { SurveysAPI } from '../../API';
import { applyOutcomeLanguage } from '../SurveyCallbackPages/applyOutcomeLanguage';

class SurveyAttemptMessage extends Component {
    componentDidMount() {
        // Render in the panelist's account language (users.language). The
        // backend redirect carries ?userid=...; fetch the resolved language and
        // apply it (session-only — LanguageToggle still overrides afterwards).
        const queryString = window.location.href.split('?')[1] || '';
        const userId = new URLSearchParams(queryString).get('userid');
        if (userId) {
            SurveysAPI.getUserLanguagePlain({ userId })
                .then((data) => this.props.applyOutcomeLanguage(data && data.language))
                .catch((e) => console.warn('[attempted-message language] failed', e));
        }
    }

    render()
    {
        const { t } = this.props;
        const containerStyle = {
            textAlign: 'center',
            padding: '20px',
            border: '1px solid #ddd',
            borderRadius: '5px',
            maxWidth: '400px',
            margin: 'auto',
            marginTop: '50px',
        };

        const messageStyle = {
            fontSize: '18px',
            color: '#333',
            marginBottom: '20px',
        };

        return (
            <div style={{ position: 'relative', minHeight: '100vh' }}>
                {/* Top-right language toggle (matches /privacy-policy placement).
                    Renders nothing on en-only portals. */}
                <div style={{ position: 'absolute', top: 12, right: 16, zIndex: 1200 }}>
                    <LanguageToggle />
                </div>
                <div style={containerStyle}>
                    <img src={branding.logo || Assets.Logo2}  style={{width:'100%'}} alt={`${country.brandName} Logo`}/>
                    <div style={messageStyle}>
                        <p>{t('survey.alreadyAttempted.message')}</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default SurveyAttemptMessage;

const mapStateToProps = (state) => {
    return {
        isAuth: state.adminUser.adminUser.isAuthenticated,
        token: state.adminUser.adminUser.token,
        language: state.adminUser.adminUser.language,
        isLoading: state.adminUser.adminUser.loading,
        error: state.adminUser.adminUser.error,
    };
};

const mapDispatchToProps = (dispatch) => ({
    authRegistration: (...args) => dispatch(authRegistration(...args)),
    applyOutcomeLanguage: (lang) => applyOutcomeLanguage(dispatch, lang),
});

const SurveyAttemptMessageWithState = withRouter(connect(
    mapStateToProps, mapDispatchToProps,
)(withTranslation()(SurveyAttemptMessage)));

SurveyAttemptMessage.propTypes = {
    language: PropTypes.string
}

export {
    SurveyAttemptMessage,
    SurveyAttemptMessageWithState,
};
